
/** Use this to enforce that an array contains all possible values that it can have (if it's a union type or keyof).
 * Code pulled from: https://stackoverflow.com/questions/60131681/make-sure-array-has-all-types-from-a-union
 * 
*/
export const HasAllValues = <T>() => <U extends T[]>(
    array: U & ([T] extends [U[number]] ? unknown : 'Invalid') & { 0:T }
  ) => array;

export type NonUndefined<T> = T extends undefined ? never : T;

export type NonEmptyArray<T> = [T, ...T[]];

// A type that represents an object of type T with an arbitrary property defined by a string
// The type enforces that the object has a property with the given key, type also includes the type T
// Example:
// type Test = HasProp<{a: number, b: string}, 'c'>;
// const test: Test = {a: 1, b: 'test', c: 'test'}; // This is valid
// const test2: Test = {a: 1, b: 'test'}; // This is invalid
// const test3: Test = {a: 1, b: 'test', c: 1}; // This is valid
// const test4: Test = {a: 1, b: 'test', d: 1}; // This is invalid
export type HasProp<T, K extends string> = T & Record<K, any>;